import { StyleSheet } from "@react-pdf/renderer";

const stylePDF = StyleSheet.create({
  page: { padding: 20 },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  logo: { width: 50, height: 50, marginRight: 10 },
  image: { width: 25, aspectRatio: 1, marginRight: 10 },
  text: { fontSize: 18, fontWeight: "bold" },
  textCenter: { fontSize: 18, textAlign: "center" },
  info: { fontSize: 12, marginRight: 20, fontWeight: "bold" },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
  },
  title: { fontSize: 16, marginRight: 20, fontWeight: "bold" },
  rowTable: { flexDirection: "row" },
  header: { backgroundColor: "#eee", fontWeight: "bold" },
  cell: {
    flex: 1,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
    fontSize: 10,
    textAlign: "center",
  },
});

export default stylePDF;
